import $ from 'jquery';
import config from '../config';
const URL_API = config.urlApi+'controllers/getAllVisitors.controller.php';

export default function getTotalVisits(values){
    return $.ajax({
        data: values,
        url: URL_API,
        type: 'GET'
    })
}